import React, { Component } from 'react';
import { Link } from "react-router-dom";

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";

//i18n
//import { withNamespaces } from "react-i18next";

//Import Images
import megamenuImg from "../../assets/images/users/utjd_logo.jpg";

class MegaMenu extends Component {
    state = {
        megaMenu : false
    }
    render() {
        return (
            <React.Fragment>
                        <Dropdown  className="dropdown-mega d-none d-lg-block ml-2" isOpen={this.state.megaMenu} toggle={() => { this.setState({ megaMenu: !this.state.megaMenu }) }}>
                            <DropdownToggle tag="button" type="button" caret className="btn header-item waves-effect">
                                Mega Menu{" "}
                                <i className="mdi mdi-chevron-down"></i> 
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-megamenu">
                                <Row>
                                    <Col sm={8}>
                
                                        <Row>

                                            <Col md={4}>
                                                <h5 className="font-size-14 mt-0">Modules</h5>
                                                <ul className="list-unstyled megamenu-list">
                                                    <li>
                                                        <Link to="/campinfo">Camp Info</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/datastore">Submit Data</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#">Uploaded File Info</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#">Testimony Registration</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#">Projects (N)</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#">Tasks (N)</Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#">Contacts (N)</Link>
                                                    </li>
                                                </ul>
                                            </Col>

                                            <Col sm={5}>
                                                <div>
                                                    <img src={megamenuImg} alt="" className="img-fluid mx-auto d-block"/>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                            </DropdownMenu>
                        </Dropdown>
            </React.Fragment>
        );
    }
}

export default (MegaMenu);